import { indicatorsMap } from '../dashboard';
import BarBase from './BarBase';

const NOT_A_PROGRAM = new Set([
  'isPeerRequested',
  'isTelehealth',
  'isInjectable',
  'isMinor',
]);

const ProgramChart = ({ chartData }) => {
  const data = [];
  const programCounts = {};

  for (const alertElement of chartData) {
    const { indicators } = alertElement;
    for (const [program, isSelected] of Object.entries(indicators)) {
      if (NOT_A_PROGRAM.has(program)) continue;
      if (!isSelected) continue;
      if (!(program in programCounts)) {
        programCounts[program] = {
          label: indicatorsMap[program],
          value: 1,
        };
      } else {
        programCounts[program].value += 1;
      }
    }
  }

  for (const program of Object.values(programCounts)) {
    data.push(program);
  }

  return (
    <BarBase
      title={'Programs'}
      data={data}
    />
  );
};

export default ProgramChart;
